import { ContractActionRequestContractAction } from '@urbanx/agx.campaigns.client'
import CampaignsService from 'services/campaignsService'

interface IPerformContractAction {
  getAuthToken: () => Promise<string>
  campaignId: string
  contractId: string
  contractStageAction: ContractActionRequestContractAction
}

const PerformContractAction = async ({
  getAuthToken,
  campaignId,
  contractId,
  contractStageAction,
}: IPerformContractAction): Promise<void> => {
  const token = await getAuthToken()
  

  const service = new CampaignsService(token)
  

  await service.campaignsService.post('PerformContractAction', {
    CampaignId: campaignId,
    ContractId: contractId,
    ContractAction: contractStageAction,
  })
}

export default PerformContractAction
